import React, { useEffect, useState } from 'react';
import EntityMultiSelect, { entityLabel, selectedEntityIds } from '../shared/components/EntityMultiSelect';
const catalogs = {
  client: () => import('./clients/services/clients.service').then((api) => api.listClientsResult()),
  supplier: () => import('./suppliers/services/suppliers.service').then((api) => api.listSuppliersResult()),
  staff: () => import('./staff/services/staff.service').then((api) => api.listStaffResult()),
};
const labels = { client: 'Clienti', supplier: 'Fornitori', staff: 'Membri del team' };
export default function PartyFields({ value, onFieldChange, kinds = 'client', disabled = false, onSelectionChange }) {
  const [state, setState] = useState({ options: {}, error: '' });
  useEffect(() => {
    let active = true;
    const types = kinds.split(',');
    Promise.allSettled(types.map((type) => catalogs[type]())).then((results) => {
      if (!active) return;
      const options = {}, errors = [];
      results.forEach((result, index) => {
        const type = types[index];
        options[type] = result.status === 'fulfilled' && result.value?.ok ? result.value.data || [] : [];
        if (result.status === 'rejected' || !result.value?.ok) errors.push(`${labels[type]} non disponibili.`);
      });
      setState({ options, error: errors.join(' ') });
    });
    return () => { active = false; };
  }, [kinds]);
  return <div className="space-y-3">
    {state.error ? <p className="wt-inline-error" role="alert">{state.error}</p> : null}
    {kinds.split(',').map((kind) => <div key={kind}>
      <p>{labels[kind]}</p>
      <EntityMultiSelect label={labels[kind]} options={state.options[kind] || []} value={selectedEntityIds(value, kind)} disabled={disabled}
        onChange={(ids) => {
          if (onSelectionChange) { onSelectionChange(kind, ids, state.options[kind] || []); return; }
          onFieldChange(`${kind}Ids`, ids);
          onFieldChange(`${kind}Id`, ids[0] || '');
          const names = ids.map((id) => entityLabel(state.options[kind]?.find((item) => String(item.id) === id))).join('; ');
          onFieldChange(kind === 'client' ? 'client' : kind === 'supplier' ? 'supplierName' : 'assignee', names);
        }} />
    </div>)}
  </div>;
}
